export default {
    showVariationsModal: {
        copy: 'Copier',
        contentVariation: 'Variation du contenu',
        chosenContent: 'Contenu choisi',
        chosenContentPlaceholder: 'Veuillez saisir',
        continue: 'Continuer',
        generateNewContent: 'Générer du nouveau contenu',
        type: 'Type :',
        contentTitle: 'Titre :',
        descriptionLabel: 'Description :',
        keywordsLabel: 'Mots-clés :',
        writingTone: "Ton d'écriture :",
        context: 'Contexte :',
        cancel: 'Annuler',
    },
};
